/**
 * DCRP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpParams,
  HttpResponse,
} from '@angular/common/http';
import { RecoveryCaseIEnumerableResponse } from '../models/recoveryCaseIEnumerableResponse';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Int32Response } from '../models/int32Response';
import { RecoveryRequest } from '../models/recovery-request';
import { VendorRecoveryCaseResponse } from '../models/vendorRecoveryCaseResponse';
import { CreateRecoveryCase } from '../models/createRecoveryCase';
import { RecoveryClaimReferenceDocumentResponse } from '../models/recoveryClaimReferenceDocumentResponse';
import { ClaimReferenceDocumentRequest } from '../models/claimReferenceDocumentRequest';
import { CaseActivityLogsDtoListResponse } from '../models/caseActivityLogsDtoListResponse';
import { RecoveryCaseType } from '../models/recoveryCaseType';
import { UpdateRecoveryCase } from '../models/updateRecoveryCase';
import { RecoveryCaseOverview } from '../models/recoveryCaseOverview';
import { CustomHttpUrlEncodingCodec } from '../../services/encoder';
import { RecoveryCase } from '../models/recoveryCase';
import { RecoveryCasePredefinedFilter } from '../models/recoveryCasePredefinedFilter';
import { SortOrder } from '../models/sortOrder';
import { LinkedCaseRequest } from '../models/linkedCaseRequest';
import { FeaRecoverableCostsSummary } from '../models/feaRecoverableCostsSummary';
import { UpdateBulkRecoveryCase } from '../models/updateBulkRecoveryCase';
import { CreateBulkRecoveryCase } from '../models/createBulkRecoveryCase';
import { RecoveryCaseResponse } from '../models/recoveryCaseResponse';

@Injectable()
export class RecoveryCaseService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * This API will fetch count of recovery cases based on the recovery type and other filters
   *
   * @param recoveryCaseType
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param caseId
   * @param caseStatuses
   * @param equipmentNumber
   * @param invoiceNumber
   * @param workOrderNumber
   * @param bookingNumber
   * @param podClusters
   * @param podCountries
   * @param dateRangeFromDateTime
   * @param dateRangeToDateTime
   * @param assignedTo
   * @param shopCountryCode
   * @param podRegions
   * @param shopCodes
   * @param createdBy
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesCountGet(
    recoveryRequest: RecoveryRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Int32Response>;
  public recoveryCasesCountGet(
    recoveryRequest: RecoveryRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Int32Response>>;
  public recoveryCasesCountGet(
    recoveryRequest: RecoveryRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Int32Response>>;
  public recoveryCasesCountGet(
    recoveryRequest: RecoveryRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      recoveryRequest.recoveryCaseType === null ||
      recoveryRequest.recoveryCaseType === undefined
    ) {
      throw new Error(
        'Required parameter recoveryCaseType was null or undefined when calling recoveryCasesGet.'
      );
    }

    let queryParameters = new HttpParams();
    if (
      recoveryRequest.recoveryCaseType !== undefined &&
      recoveryRequest.recoveryCaseType !== null
    ) {
      queryParameters = queryParameters.set(
        'RecoveryCaseType',
        <any>recoveryRequest.recoveryCaseType
      );
    }
    if (
      recoveryRequest.paginationPageNumber !== undefined &&
      recoveryRequest.paginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>recoveryRequest.paginationPageNumber
      );
    }
    if (
      recoveryRequest.paginationPageSize !== undefined &&
      recoveryRequest.paginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>recoveryRequest.paginationPageSize
      );
    }
    if (
      recoveryRequest.paginationSortOrder !== undefined &&
      recoveryRequest.paginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>recoveryRequest.paginationSortOrder
      );
    }
    if (
      recoveryRequest.paginationSortColumn !== undefined &&
      recoveryRequest.paginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>recoveryRequest.paginationSortColumn
      );
    }
    if (
      recoveryRequest.caseId !== undefined &&
      recoveryRequest.caseId !== null
    ) {
      queryParameters = queryParameters.set(
        'CaseId',
        <any>recoveryRequest.caseId
      );
    }
    if (
      recoveryRequest.isImportReturn !== null &&
      recoveryRequest.isImportReturn !== undefined
    ) {
      queryParameters = queryParameters.set(
        'IsImportReturn',
        <any>recoveryRequest.isImportReturn
      );
    }
    if (recoveryRequest.caseStatuses) {
      recoveryRequest.caseStatuses.forEach((element) => {
        queryParameters = queryParameters.append('CaseStatuses', <any>element);
      });
    }
    if (recoveryRequest.workOrderStatusCode) {
      recoveryRequest.workOrderStatusCode.forEach((element) => {
        queryParameters = queryParameters.append(
          'WorkOrderStatusCodes',
          <any>element
        );
      });
    }
    if (recoveryRequest.workOrderMode) {
      recoveryRequest.workOrderMode.forEach((element) => {
        queryParameters = queryParameters.append(
          'WorkOrderModes',
          <any>element
        );
      });
    }
    if (recoveryRequest.workOrderAssignedUsers) {
      recoveryRequest.workOrderAssignedUsers.forEach((element) => {
        queryParameters = queryParameters.append(
          'WorkOrderAssignedUsers',
          <any>element
        );
      });
    }
    if (
      recoveryRequest.dateRange &&
      recoveryRequest.dateRange?.fromDateTime !== undefined &&
      recoveryRequest.dateRange?.fromDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRange.FromDateTime',
        <any>recoveryRequest.dateRange.fromDateTime.toISOString()
      );
    }
    if (
      recoveryRequest.dateRange &&
      recoveryRequest.dateRange.toDateTime !== undefined &&
      recoveryRequest.dateRange.toDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRange.ToDateTime',
        <any>recoveryRequest.dateRange.toDateTime.toISOString()
      );
    }
    if (
      recoveryRequest.equipmentNumber !== undefined &&
      recoveryRequest.equipmentNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'EquipmentNumber',
        <any>recoveryRequest.equipmentNumber
      );
    }
    if (
      recoveryRequest.invoiceNumber !== undefined &&
      recoveryRequest.invoiceNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'InvoiceNumber',
        <any>recoveryRequest.invoiceNumber
      );
    }
    if (
      recoveryRequest.workOrderNumber !== undefined &&
      recoveryRequest.workOrderNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'WorkOrderNumber',
        <any>recoveryRequest.workOrderNumber
      );
    }
    if (
      recoveryRequest.bookingNumber !== undefined &&
      recoveryRequest.bookingNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'BookingNumber',
        <any>recoveryRequest.bookingNumber
      );
    }
    if (recoveryRequest.podClusters) {
      recoveryRequest.podClusters.forEach((element) => {
        queryParameters = queryParameters.append('PodClusters', <any>element);
      });
    }
    if (recoveryRequest.podCountries) {
      recoveryRequest.podCountries.forEach((element) => {
        queryParameters = queryParameters.append('PodCountries', <any>element);
      });
    }
    if (
      recoveryRequest.dateRange &&
      recoveryRequest.dateRange?.fromDateTime !== undefined &&
      recoveryRequest.dateRange?.fromDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRange.FromDateTime',
        <any>recoveryRequest.dateRange.fromDateTime.toISOString()
      );
    }
    if (
      recoveryRequest.dateRange &&
      recoveryRequest.dateRange.toDateTime !== undefined &&
      recoveryRequest.dateRange.toDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRange.ToDateTime',
        <any>recoveryRequest.dateRange.toDateTime.toISOString()
      );
    }
    if (
      recoveryRequest.assignedTo !== undefined &&
      recoveryRequest.assignedTo !== null
    ) {
      queryParameters = queryParameters.set(
        'AssignedTo',
        <any>recoveryRequest.assignedTo
      );
    }
    if (recoveryRequest.shopCountryCode) {
      recoveryRequest.shopCountryCode.forEach((element) => {
        queryParameters = queryParameters.append(
          'ShopCountryCode',
          <any>element
        );
      });
    }
    if (recoveryRequest.podRegions) {
      recoveryRequest.podRegions.forEach((element) => {
        queryParameters = queryParameters.append('PodRegions', <any>element);
      });
    }
    if (recoveryRequest.shopCodes) {
      recoveryRequest.shopCodes.forEach((element) => {
        queryParameters = queryParameters.append('ShopCodes', <any>element);
      });
    }
    if (recoveryRequest.shopRegions) {
      recoveryRequest.shopRegions.forEach((element) => {
        queryParameters = queryParameters.append('ShopRegions', <any>element);
      });
    }
    if (recoveryRequest.createdBy) {
      recoveryRequest.createdBy.forEach((element) => {
        queryParameters = queryParameters.append('CreatedBy', <any>element);
      });
    }
    if (
      recoveryRequest.dateRangeFilterType !== undefined &&
      recoveryRequest.dateRangeFilterType !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRangeFilterType',
        <any>recoveryRequest.dateRangeFilterType
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<Int32Response>(
      'get',
      `${this.basePath}/recovery-cases/count`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will update a recovery case based on the provided case ID and inputs.
   *
   * @param caseId The unique identifier of the recovery case.
   * @param body Request of Fleet.DCRP.Api.Domain.Request.RecoveryClaims.UpdateRecoveryCase
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesCaseIdPut(
    caseId: number,
    body?: UpdateRecoveryCase,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VendorRecoveryCaseResponse>;
  public recoveryCasesCaseIdPut(
    caseId: number,
    body?: UpdateRecoveryCase,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VendorRecoveryCaseResponse>>;
  public recoveryCasesCaseIdPut(
    caseId: number,
    body?: UpdateRecoveryCase,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VendorRecoveryCaseResponse>>;
  public recoveryCasesCaseIdPut(
    caseId: number,
    body?: UpdateRecoveryCase,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling recoveryCasesCaseIdPut.'
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];

    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];

    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<VendorRecoveryCaseResponse>(
      'put',
      `${this.basePath}/recovery-cases/${encodeURIComponent(String(caseId))}`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will fetch list of recovery cases based on the recovery type and other filters
   *
   * @param recoveryCaseType
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param caseId
   * @param caseStatuses
   * @param equipmentNumber
   * @param invoiceNumber
   * @param workOrderNumber
   * @param bookingNumber
   * @param podClusters
   * @param podCountries
   * @param dateRangeFromDateTime
   * @param dateRangeToDateTime
   * @param assignedTo
   * @param shopCountryCode
   * @param podRegions
   * @param shopCodes
   * @param createdBy
   * @param workOrderStatusCode
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesGet(
    recoveryRequest: RecoveryRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<RecoveryCaseIEnumerableResponse>;
  public recoveryCasesGet(
    recoveryRequest: RecoveryRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<RecoveryCaseIEnumerableResponse>>;
  public recoveryCasesGet(
    recoveryRequest: RecoveryRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<RecoveryCaseIEnumerableResponse>>;
  public recoveryCasesGet(
    recoveryRequest: RecoveryRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      recoveryRequest.recoveryCaseType === null ||
      recoveryRequest.recoveryCaseType === undefined
    ) {
      throw new Error(
        'Required parameter recoveryCaseType was null or undefined when calling recoveryCasesGet.'
      );
    }

    let queryParameters = new HttpParams();
    if (
      recoveryRequest.recoveryCaseType !== undefined &&
      recoveryRequest.recoveryCaseType !== null
    ) {
      queryParameters = queryParameters.set(
        'RecoveryCaseType',
        <any>recoveryRequest.recoveryCaseType
      );
    }
    if (
      recoveryRequest.paginationPageNumber !== undefined &&
      recoveryRequest.paginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>recoveryRequest.paginationPageNumber
      );
    }
    if (
      recoveryRequest.paginationPageSize !== undefined &&
      recoveryRequest.paginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>recoveryRequest.paginationPageSize
      );
    }
    if (
      recoveryRequest.paginationSortOrder !== undefined &&
      recoveryRequest.paginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>recoveryRequest.paginationSortOrder
      );
    }
    if (
      recoveryRequest.paginationSortColumn !== undefined &&
      recoveryRequest.paginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>recoveryRequest.paginationSortColumn
      );
    }
    if (
      recoveryRequest.caseId !== undefined &&
      recoveryRequest.caseId !== null
    ) {
      queryParameters = queryParameters.set(
        'CaseId',
        <any>recoveryRequest.caseId
      );
    }
    if (recoveryRequest.caseStatuses) {
      recoveryRequest.caseStatuses.forEach((element) => {
        queryParameters = queryParameters.append('CaseStatuses', <any>element);
      });
    }
    if (
      recoveryRequest.isImportReturn !== null &&
      recoveryRequest.isImportReturn !== undefined
    ) {
      queryParameters = queryParameters.set(
        'IsImportReturn',
        <any>recoveryRequest.isImportReturn
      );
    }
    if (recoveryRequest.workOrderStatusCode) {
      recoveryRequest.workOrderStatusCode.forEach((element) => {
        queryParameters = queryParameters.append(
          'WorkOrderStatusCodes',
          <any>element
        );
      });
    }
    if (recoveryRequest.workOrderMode) {
      recoveryRequest.workOrderMode.forEach((element) => {
        queryParameters = queryParameters.append(
          'WorkOrderModes',
          <any>element
        );
      });
    }
    if (recoveryRequest.workOrderAssignedUsers) {
      recoveryRequest.workOrderAssignedUsers.forEach((element) => {
        queryParameters = queryParameters.append(
          'WorkOrderAssignedUsers',
          <any>element
        );
      });
    }
    if (
      recoveryRequest.equipmentNumber !== undefined &&
      recoveryRequest.equipmentNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'EquipmentNumber',
        <any>recoveryRequest.equipmentNumber
      );
    }
    if (
      recoveryRequest.invoiceNumber !== undefined &&
      recoveryRequest.invoiceNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'InvoiceNumber',
        <any>recoveryRequest.invoiceNumber
      );
    }
    if (
      recoveryRequest.workOrderNumber !== undefined &&
      recoveryRequest.workOrderNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'WorkOrderNumber',
        <any>recoveryRequest.workOrderNumber
      );
    }
    if (
      recoveryRequest.bookingNumber !== undefined &&
      recoveryRequest.bookingNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'BookingNumber',
        <any>recoveryRequest.bookingNumber
      );
    }
    if (recoveryRequest.podClusters) {
      recoveryRequest.podClusters.forEach((element) => {
        queryParameters = queryParameters.append('PodClusters', <any>element);
      });
    }
    if (recoveryRequest.podCountries) {
      recoveryRequest.podCountries.forEach((element) => {
        queryParameters = queryParameters.append('PodCountries', <any>element);
      });
    }
    if (
      recoveryRequest.dateRange &&
      recoveryRequest.dateRange?.fromDateTime !== undefined &&
      recoveryRequest.dateRange?.fromDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRange.FromDateTime',
        <any>recoveryRequest.dateRange.fromDateTime.toISOString()
      );
    }
    if (
      recoveryRequest.dateRange &&
      recoveryRequest.dateRange.toDateTime !== undefined &&
      recoveryRequest.dateRange.toDateTime !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRange.ToDateTime',
        <any>recoveryRequest.dateRange.toDateTime.toISOString()
      );
    }
    if (
      recoveryRequest.assignedTo !== undefined &&
      recoveryRequest.assignedTo !== null
    ) {
      queryParameters = queryParameters.set(
        'AssignedTo',
        <any>recoveryRequest.assignedTo
      );
    }
    if (
      recoveryRequest.isInvoiced !== undefined &&
      recoveryRequest.isInvoiced !== null
    ) {
      queryParameters = queryParameters.set(
        'IsInvoiced',
        <any>recoveryRequest.isInvoiced
      );
    }
    if (recoveryRequest.shopCountryCode) {
      recoveryRequest.shopCountryCode.forEach((element) => {
        queryParameters = queryParameters.append(
          'ShopCountryCode',
          <any>element
        );
      });
    }
    if (recoveryRequest.podRegions) {
      recoveryRequest.podRegions.forEach((element) => {
        queryParameters = queryParameters.append('PodRegions', <any>element);
      });
    }
    if (recoveryRequest.shopCodes) {
      recoveryRequest.shopCodes.forEach((element) => {
        queryParameters = queryParameters.append('ShopCodes', <any>element);
      });
    }
    if (recoveryRequest.shopRegions) {
      recoveryRequest.shopRegions.forEach((element) => {
        queryParameters = queryParameters.append('ShopRegions', <any>element);
      });
    }
    if (recoveryRequest.createdBy) {
      recoveryRequest.createdBy.forEach((element) => {
        queryParameters = queryParameters.append('CreatedBy', <any>element);
      });
    }
    if (
      recoveryRequest.dateRangeFilterType !== undefined &&
      recoveryRequest.dateRangeFilterType !== null
    ) {
      queryParameters = queryParameters.set(
        'DateRangeFilterType',
        <any>recoveryRequest.dateRangeFilterType
      );
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];

    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<RecoveryCaseIEnumerableResponse>(
      'get',
      `${this.basePath}/recovery-cases`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will create a new recovery case based on provided inputs
   *
   * @param body Request of Fleet.DCRP.Api.Domain.Request.RecoveryClaims.CreateRecoveryCase
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesPost(
    body?: CreateRecoveryCase,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<VendorRecoveryCaseResponse>;
  public recoveryCasesPost(
    body?: CreateRecoveryCase,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<VendorRecoveryCaseResponse>>;
  public recoveryCasesPost(
    body?: CreateRecoveryCase,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<VendorRecoveryCaseResponse>>;
  public recoveryCasesPost(
    body?: CreateRecoveryCase,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<VendorRecoveryCaseResponse>(
      'post',
      `${this.basePath}/recovery-cases`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will fetch list of attachments for provided case ID
   *
   * @param caseId Case ID for which attachments need to be fetched
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesCaseIdAttachmentsGet(
    caseId: number,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<RecoveryClaimReferenceDocumentResponse>;
  public recoveryCasesCaseIdAttachmentsGet(
    caseId: number,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<RecoveryClaimReferenceDocumentResponse>>;
  public recoveryCasesCaseIdAttachmentsGet(
    caseId: number,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<RecoveryClaimReferenceDocumentResponse>>;
  public recoveryCasesCaseIdAttachmentsGet(
    caseId: number,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling recoveryCasesCaseIdAttachmentsGet.'
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<RecoveryClaimReferenceDocumentResponse>(
      'get',
      `${this.basePath}/recovery-cases/${encodeURIComponent(String(caseId))}/attachments`,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will add attachments to provided case ID
   *
   * @param caseId Case ID for which attachments need to be added
   * @param body Attachments to be added
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesCaseIdAttachmentsPost(
    caseId: number,
    aPIVersion?: string,
    body?: ClaimReferenceDocumentRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<RecoveryClaimReferenceDocumentResponse>;
  public recoveryCasesCaseIdAttachmentsPost(
    caseId: number,
    aPIVersion?: string,
    body?: ClaimReferenceDocumentRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<RecoveryClaimReferenceDocumentResponse>>;
  public recoveryCasesCaseIdAttachmentsPost(
    caseId: number,
    aPIVersion?: string,
    body?: ClaimReferenceDocumentRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<RecoveryClaimReferenceDocumentResponse>>;
  public recoveryCasesCaseIdAttachmentsPost(
    caseId: number,
    aPIVersion?: string,
    body?: ClaimReferenceDocumentRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling recoveryCasesCaseIdAttachmentsPost.'
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<RecoveryClaimReferenceDocumentResponse>(
      'post',
      `${this.basePath}/recovery-cases/${encodeURIComponent(String(caseId))}/attachments`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Gets the case activity logs
   *
   * @param caseId
   * @param recoveryCaseType
   * @param aPIVersion
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesCaseIdActivityLogsGet(
    caseId: number,
    recoveryCaseType: RecoveryCaseType,
    aPIVersion?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CaseActivityLogsDtoListResponse>;
  public recoveryCasesCaseIdActivityLogsGet(
    caseId: number,
    recoveryCaseType: RecoveryCaseType,
    aPIVersion?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CaseActivityLogsDtoListResponse>>;
  public recoveryCasesCaseIdActivityLogsGet(
    caseId: number,
    recoveryCaseType: RecoveryCaseType,
    aPIVersion?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CaseActivityLogsDtoListResponse>>;
  public recoveryCasesCaseIdActivityLogsGet(
    caseId: number,
    recoveryCaseType: RecoveryCaseType,
    aPIVersion?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    if (recoveryCaseType === null || recoveryCaseType === undefined) {
      throw new Error(
        'Required parameter recoveryCaseType was null or undefined when calling recoveryCasesCaseIdActivityLogsGet.'
      );
    }

    let queryParameters = new HttpParams();
    if (recoveryCaseType !== undefined && recoveryCaseType !== null) {
      queryParameters = queryParameters.set(
        'RecoveryCaseType',
        <any>recoveryCaseType
      );
    }

    // to determine the Accept header
    const httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    return this.httpClient.request<CaseActivityLogsDtoListResponse>(
      'get',
      `${this.basePath}/recovery-cases/${encodeURIComponent(String(caseId))}/activity-logs`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will download list of recovery cases based on the recovery type and other filters
   *
   * @param recoveryCaseType
   * @param shopCodes
   * @param shopRegions
   * @param dateRangeFromDateTime
   * @param dateRangeToDateTime
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesExportGet(
    recoveryCaseType: RecoveryCaseType,
    shopCodes: Array<string>,
    shopRegions: Array<string>,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Blob>;
  public recoveryCasesExportGet(
    recoveryCaseType: RecoveryCaseType,
    shopCodes: Array<string>,
    shopRegions: Array<string>,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Blob>>;
  public recoveryCasesExportGet(
    recoveryCaseType: RecoveryCaseType,
    shopCodes: Array<string>,
    shopRegions: Array<string>,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Blob>>;
  public recoveryCasesExportGet(
    recoveryCaseType: RecoveryCaseType,
    shopCodes: Array<string>,
    shopRegions: Array<string>,
    dateRangeFromDateTime?: Date,
    dateRangeToDateTime?: Date,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (recoveryCaseType === null || recoveryCaseType === undefined) {
      throw new Error(
        'Required parameter recoveryCaseType was null or undefined when calling recoveryCasesExportGet.'
      );
    }

    if (shopCodes === null || shopCodes === undefined) {
      throw new Error(
        'Required parameter shopCodes was null or undefined when calling recoveryCasesExportGet.'
      );
    }

    if (shopRegions === null || shopRegions === undefined) {
      throw new Error(
        'Required parameter shopRegions was null or undefined when calling recoveryCasesExportGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });

    if (recoveryCaseType !== undefined && recoveryCaseType !== null) {
      queryParameters = queryParameters.set(
        'RecoveryCaseType',
        <any>recoveryCaseType
      );
    }
    if (shopCodes) {
      shopCodes.forEach((element) => {
        queryParameters = queryParameters.append('ShopCodes', <any>element);
      });
    }
    if (shopRegions) {
      shopRegions.forEach((element) => {
        queryParameters = queryParameters.append('ShopRegions', <any>element);
      });
    }
    if (dateRangeFromDateTime !== undefined && dateRangeFromDateTime !== null) {
      queryParameters = queryParameters.set(
        'DateRange.FromDateTime',
        <any>dateRangeFromDateTime.toISOString()
      );
    }
    if (dateRangeToDateTime !== undefined && dateRangeToDateTime !== null) {
      queryParameters = queryParameters.set(
        'DateRange.ToDateTime',
        <any>dateRangeToDateTime.toISOString()
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request(
      'get',
      `${this.basePath}/recovery-cases/export`,
      {
        params: queryParameters,
        responseType: 'blob',
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will fetch case overview based on case ID and recovery type.
   *
   * @param caseId The unique identifier of the recovery case.
   * @param recoveryCaseType Type of recovery case.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesCaseIdOverviewGet(
    caseId: number,
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<RecoveryCaseOverview>;
  public recoveryCasesCaseIdOverviewGet(
    caseId: number,
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<RecoveryCaseOverview>>;
  public recoveryCasesCaseIdOverviewGet(
    caseId: number,
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<RecoveryCaseOverview>>;
  public recoveryCasesCaseIdOverviewGet(
    caseId: number,
    recoveryCaseType?: RecoveryCaseType,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (caseId === null || caseId === undefined) {
      throw new Error(
        'Required parameter caseId was null or undefined when calling recoveryCasesCaseIdOverviewGet.'
      );
    }

    let queryParameters = new HttpParams();
    if (recoveryCaseType !== undefined && recoveryCaseType !== null) {
      queryParameters = queryParameters.set(
        'recoveryCaseType',
        <any>recoveryCaseType
      );
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    return this.httpClient.request<RecoveryCaseOverview>(
      'get',
      `${this.basePath}/recovery-cases/${encodeURIComponent(String(caseId))}/overview`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will fetch list of linked recovery cases based on the recovery type and other filters
   *
   * @param recoveryCaseType
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param caseId
   * @param groupIds
   * @param predefinedFilters
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesLinkedCasesGet(
    recoveryLinkedRequest: LinkedCaseRequest,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<RecoveryCase> | Blob>;
  public recoveryCasesLinkedCasesGet(
    recoveryLinkedRequest: LinkedCaseRequest,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<RecoveryCase> | Blob>>;
  public recoveryCasesLinkedCasesGet(
    recoveryLinkedRequest: LinkedCaseRequest,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<RecoveryCase> | Blob>>;
  public recoveryCasesLinkedCasesGet(
    recoveryLinkedRequest: LinkedCaseRequest,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (
      recoveryLinkedRequest.recoveryCaseType === null ||
      recoveryLinkedRequest.recoveryCaseType === undefined
    ) {
      throw new Error(
        'Required parameter recoveryCaseType was null or undefined when calling recoveryCasesLinkedCasesGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (
      recoveryLinkedRequest.recoveryCaseType !== undefined &&
      recoveryLinkedRequest.recoveryCaseType !== null
    ) {
      queryParameters = queryParameters.set(
        'RecoveryCaseType',
        <any>recoveryLinkedRequest.recoveryCaseType
      );
    }
    if (
      recoveryLinkedRequest.paginationPageNumber !== undefined &&
      recoveryLinkedRequest.paginationPageNumber !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>recoveryLinkedRequest.paginationPageNumber
      );
    }
    if (
      recoveryLinkedRequest.paginationPageSize !== undefined &&
      recoveryLinkedRequest.paginationPageSize !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>recoveryLinkedRequest.paginationPageSize
      );
    }
    if (
      recoveryLinkedRequest.paginationSortOrder !== undefined &&
      recoveryLinkedRequest.paginationSortOrder !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>recoveryLinkedRequest.paginationSortOrder
      );
    }
    if (
      recoveryLinkedRequest.paginationSortColumn !== undefined &&
      recoveryLinkedRequest.paginationSortColumn !== null
    ) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>recoveryLinkedRequest.paginationSortColumn
      );
    }
    if (
      recoveryLinkedRequest.caseId !== undefined &&
      recoveryLinkedRequest.caseId !== null
    ) {
      queryParameters = queryParameters.set(
        'CaseId',
        <any>recoveryLinkedRequest.caseId
      );
    }
    if (
      recoveryLinkedRequest.stageId !== undefined &&
      recoveryLinkedRequest.stageId !== null
    ) {
      queryParameters = queryParameters.set(
        'StageId',
        <any>recoveryLinkedRequest.stageId
      );
    }

    if (recoveryLinkedRequest.groupIds) {
      recoveryLinkedRequest.groupIds.forEach((element) => {
        queryParameters = queryParameters.append('GroupIds', <any>element);
      });
    }
    if (
      recoveryLinkedRequest.exportToExcel !== undefined &&
      recoveryLinkedRequest.exportToExcel !== null
    ) {
      queryParameters = queryParameters.set(
        'ExportToExcel',
        <any>recoveryLinkedRequest.exportToExcel
      );
    }
    if (recoveryLinkedRequest.predefinedFilters) {
      recoveryLinkedRequest.predefinedFilters.forEach((element) => {
        queryParameters = queryParameters.append(
          'PredefinedFilters',
          <any>element
        );
      });
    }

    let headers = this.defaultHeaders;

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    if (recoveryLinkedRequest.exportToExcel) {
      return this.httpClient.request(
        'get',
        `${this.basePath}/recovery-cases/linked-cases`,
        {
          params: queryParameters,
          responseType: 'blob',
          headers: headers,
          observe: observe,
          reportProgress: reportProgress,
        }
      );
    } else {
      return this.httpClient.request<Array<RecoveryCase>>(
        'get',
        `${this.basePath}/recovery-cases/linked-cases`,
        {
          params: queryParameters,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress,
        }
      );
    }
  }

  /**
   * This API will fetch Recoverable Costs Summary of linked recovery cases based on the recovery type
   *
   * @param recoveryCaseType
   * @param paginationPageNumber
   * @param paginationPageSize
   * @param paginationSortOrder
   * @param paginationSortColumn
   * @param caseId
   * @param groupIds
   * @param predefinedFilters
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesLinkedCasesRecoverableCostSummaryGet(
    recoveryCaseType: RecoveryCaseType,
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    caseId?: number,
    groupIds?: Array<string>,
    predefinedFilters?: Array<RecoveryCasePredefinedFilter>,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<FeaRecoverableCostsSummary>;
  public recoveryCasesLinkedCasesRecoverableCostSummaryGet(
    recoveryCaseType: RecoveryCaseType,
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    caseId?: number,
    groupIds?: Array<string>,
    predefinedFilters?: Array<RecoveryCasePredefinedFilter>,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<FeaRecoverableCostsSummary>>;
  public recoveryCasesLinkedCasesRecoverableCostSummaryGet(
    recoveryCaseType: RecoveryCaseType,
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    caseId?: number,
    groupIds?: Array<string>,
    predefinedFilters?: Array<RecoveryCasePredefinedFilter>,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<FeaRecoverableCostsSummary>>;
  public recoveryCasesLinkedCasesRecoverableCostSummaryGet(
    recoveryCaseType: RecoveryCaseType,
    paginationPageNumber?: number,
    paginationPageSize?: number,
    paginationSortOrder?: SortOrder,
    paginationSortColumn?: string,
    caseId?: number,
    groupIds?: Array<string>,
    predefinedFilters?: Array<RecoveryCasePredefinedFilter>,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (recoveryCaseType === null || recoveryCaseType === undefined) {
      throw new Error(
        'Required parameter recoveryCaseType was null or undefined when calling recoveryCasesLinkedCasesRecoverableCostSummaryGet.'
      );
    }

    let queryParameters = new HttpParams({
      encoder: new CustomHttpUrlEncodingCodec(),
    });
    if (recoveryCaseType !== undefined && recoveryCaseType !== null) {
      queryParameters = queryParameters.set(
        'RecoveryCaseType',
        <any>recoveryCaseType
      );
    }
    if (paginationPageNumber !== undefined && paginationPageNumber !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageNumber',
        <any>paginationPageNumber
      );
    }
    if (paginationPageSize !== undefined && paginationPageSize !== null) {
      queryParameters = queryParameters.set(
        'Pagination.PageSize',
        <any>paginationPageSize
      );
    }
    if (paginationSortOrder !== undefined && paginationSortOrder !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortOrder',
        <any>paginationSortOrder
      );
    }
    if (paginationSortColumn !== undefined && paginationSortColumn !== null) {
      queryParameters = queryParameters.set(
        'Pagination.SortColumn',
        <any>paginationSortColumn
      );
    }
    if (caseId !== undefined && caseId !== null) {
      queryParameters = queryParameters.set('CaseId', <any>caseId);
    }
    if (groupIds) {
      groupIds.forEach((element) => {
        queryParameters = queryParameters.append('GroupIds', <any>element);
      });
    }
    if (predefinedFilters) {
      predefinedFilters.forEach((element) => {
        queryParameters = queryParameters.append(
          'PredefinedFilters',
          <any>element
        );
      });
    }

    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<FeaRecoverableCostsSummary>(
      'get',
      `${this.basePath}/recovery-cases/linked-cases-recoverable-cost-summary`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will update multiple recovery cases in single request.
   *
   * @param body Request of Fleet.DCRP.Api.Domain.Request.RecoveryClaims.UpdateBulkRecoveryCase
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesBulkUpdatePut(
    body?: UpdateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<RecoveryCase>>;
  public recoveryCasesBulkUpdatePut(
    body?: UpdateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<RecoveryCase>>>;
  public recoveryCasesBulkUpdatePut(
    body?: UpdateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<RecoveryCase>>>;
  public recoveryCasesBulkUpdatePut(
    body?: UpdateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<RecoveryCase>>(
      'put',
      `${this.basePath}/recovery-cases/bulk-update`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * This API will create a new recovery case based on provided inputs
   *
   * @param body Create Bulk recovery case Request object
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recoveryCasesBulkCreatePost(
    body?: CreateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<RecoveryCaseResponse>;
  public recoveryCasesBulkCreatePost(
    body?: CreateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<RecoveryCaseResponse>>;
  public recoveryCasesBulkCreatePost(
    body?: CreateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<RecoveryCaseResponse>>;
  public recoveryCasesBulkCreatePost(
    body?: CreateBulkRecoveryCase,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];

    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<RecoveryCase>(
      'post',
      `${this.basePath}/recovery-cases/bulk-create`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
